import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("dfx_cart")) || [];
    } catch {
      return [];
    }
  });
  const [isCartOpen, setCartOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("dfx_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (product, size) => {
    setItems((prev) => {
      const i = prev.findIndex((p) => p.id === product.id && p.size === size);
      if (i >= 0) {
        const next = [...prev];
        next[i] = { ...next[i], qty: Math.min(next[i].qty + 1, 10) };
        return next;
      }
      return [...prev, { id: product.id, name: product.name, price: product.price, image: product.image, size, qty: 1 }];
    });
    setCartOpen(true);
  };

  const removeItem = (id, size) =>
    setItems((prev) => prev.filter((p) => !(p.id === id && p.size === size)));

  const setQty = (id, size, qty) =>
    setItems((prev) =>
      qty <= 0
        ? prev.filter((p) => !(p.id === id && p.size === size))
        : prev.map((p) => (p.id === id && p.size === size ? { ...p, qty } : p))
    );

  const clearCart = () => setItems([]);

  const subtotal = useMemo(() => items.reduce((s, i) => s + i.price * i.qty, 0), [items]);
  const count = useMemo(() => items.reduce((s, i) => s + i.qty, 0), [items]);

  const value = { items, addItem, removeItem, setQty, clearCart, subtotal, count, isCartOpen, setCartOpen };
  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}
